/**
 * Define global usage for space store
 */
import Vue from "vue"
import store from "@/store"
import CodeLists from "@/api/codeLists"
import { mapActions, mapGetters } from "vuex"
import FilterOptions from "@/api/providers/FilterOptions"
export default {
  created () {
    Vue.prototype.$setSpace = this.setSpace
    Vue.prototype.$removeSpace = this.removeSpace

    Vue.prototype.$getUi = this.getUi
    Vue.prototype.$setUi = this.setUi
    Vue.prototype.$removeUi = this.removeUi

    Vue.prototype.$api = {
      register (resources, componentId = null, namespace = null) {
        Object.keys(resources).forEach(resource => {
          let api = Vue.prototype[namespace || "$api"]
          if (
            api.hasOwnProperty(resource) &&
                  !api[resource].RIds.includes(componentId)
          ) {
            api[resource].RIds.push(componentId)
          } else if (!api.hasOwnProperty(resource)) {
            api[resource] = new resources[resource]()
            api[resource].createStore(store, resource)
            if (componentId) api[resource].RIds.push(componentId)
            // eslint-disable-next-line no-undef, no-console
          } else if (process.env.NODE_ENV !== "production") console.warn(`Trying to register a resource that already exists. Resource: ${resource}`)
        })
      },
      unregister (resources, componentId, namespace = null) {
        Object.keys(resources).forEach(resource => {
          let api = Vue.prototype[namespace || "$api"]
          if (
            api.hasOwnProperty(resource) &&
                  api[resource].RIds.length > 0 &&
                  api[resource].RIds.includes(componentId)
          ) {
            if (api[resource].RIds.length > 1) {
              api[resource].RIds.splice(api[resource].RIds.indexOf(componentId), 1)
            } else {
              api[resource].destroyStore()
              delete api[resource]
            }
          } else if (api[resource]) {
            api[resource].destroyStore()
            delete api[resource]
          }
        })
      },
      FilterOptions: new FilterOptions(store)
    }
    window.axios.interceptors.response.use((response) => { return response },
      (error) => {
        if (!error.response.status) {
          return
        }
        if (error.response.data.message) {
          this.$notify.error(error.response.data.message)
        }
        if (error.response.status === 403) {
          // this.$notify.error(error.response.data.message)
        }
        if (error.response.status && error.response.status === 401) {
          // this.authLogout()
        }
        return Promise.reject(error)
      })

    this.$api.register({ CodeLists }, this._uid)
  },
  methods: {
    ...mapActions({
      setSpace: "space/setSpace",
      removeSpace: "space/removeSpace",
      setUi: "space/setUi",
      removeUi: "space/removeUi"
    }),
    ...mapGetters({ getUi: "space/getUi" })
  }
}
